<navigation></navigation>
<cv-parse-ribbon></cv-parse-ribbon>
@if ((isAuthenticated$ | async)  || isStaffLoginRoute || isAuthCallbackRoute) {
  <div class="main-container-wrapper">
    <main id="main-container">
      @if (loading) {
        <div
          [ngClass]="{ 'full-screen': firstView }"
          class="view-loader full-screen flex flex-col flex-center-center flex-auto"
        >
          <loader color="primary"></loader>
        </div>
      }
      <div [ngClass]="{ loading: loading }" [@routerOutletVisibility]="loading ? 'hidden' : 'shown'" class="main-view">
        <custom-router-outlet></custom-router-outlet>
      </div>
    </main>
  </div>
}
<system-messages></system-messages>
<div class="fab-container">
  @if (user$ | async) {
    <div class="chat-bot-container">
      <chat-bot-button
        [avatar]="secureAvatar.avatarInstance"
        [disabled]="chatBotDisabled"
        [hidden]="chatBotHidden"
        [message]="chatBotMessage"
        [showMessage]="chatBotShowMessage"
        *authCan="chatbotFeature"
        title="{{ CurrentUser?.Agent?.FirstName }}"
      >
        <secure-avatar
          [avatarUrl]="CurrentUser?.Agent?.PortraitUrl"
          [plugEnabled]="false"
          [title]="CurrentUser?.Agent?.FirstName"
          #secureAvatar
        ></secure-avatar>
      </chat-bot-button>
    </div>
  }
</div>
